import {
    Component,
    ContentChildren,
    Input,
    Output,
    EventEmitter,
    TemplateRef,
    QueryList,
    AfterContentInit
} from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { LoadingService } from 'src/app/core/services/loading.service';
import { DeviceService } from 'src/app/core/services/device.service';

@Component({
    selector: 'app-stepper-component',
    templateUrl: './stepper.component.html',
    styleUrls: ['./stepper.css'],
    animations: [
        trigger('stepAnimation', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateY(20px)' }),
                animate('250ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
            ]),
            transition(':leave', [
                animate('250ms ease-in', style({ opacity: 0, transform: 'translateY(-20px)' }))
            ])
        ])
    ]
})

export class StepperComponent implements AfterContentInit {
    @Input() steps = 1;
    @Input() icons: string[] = [];
    @Input() animation: string[] = [];
    @Input() nameStepers: string[] = [];
    @Input() dato_evaluado: string;
    @Input() dato_evaluar: string;
    @Input() titulo_step: string;
    @Input() info_step: string;
    @Input() set step(value: number) {
        if (value !== this.currentStep && value >= 0 && value < this.steps) {
            this.currentStep = value;
        }
    }

    @Input() btnFinalizar: boolean = false;

    @Output() stepChanged = new EventEmitter<number>();
    @Output() activeSpinner = new EventEmitter<boolean>();
    @Output() finalizarChanged = new EventEmitter<void>();
    @Output() onFinish = new EventEmitter<void>();

    @ContentChildren(TemplateRef) stepTemplates!: QueryList<TemplateRef<any>>;
    templates: TemplateRef<any>[] = [];
    currentStep = 0;
    btn_next: boolean = false;
    public IsLoading: boolean;
    constructor(public loading: LoadingService ,  private deviceService: DeviceService) {

    }



    ngAfterContentInit(): void {
        this.templates = this.stepTemplates.toArray();
    }

    next() {
        if (this.loading.loading()) {
            return;
        }
        this.stepChanged.emit(this.currentStep);
    }

    finalizar(){
        this.finalizarChanged.emit();
    }

    previous() {
        if (this.currentStep > 0) {
            this.currentStep--;
            this.stepChanged.emit(this.currentStep);
        }
    }

    activeSpinning(active: boolean){
        this.IsLoading = active;
    }

    isMobileByWidth(): boolean {
     return window.innerWidth <= 768;
    }
}